package app.footyguide.web.data

import kotlinx.coroutines.await
import kotlin.js.Promise

data class HighlightlyLiveRefreshRequest(
    val url: String,
    val body: String,
)

object HighlightlyLiveRefreshApi {
    suspend fun refresh(
        date: String,
        competitionId: String,
        ttlMinutes: Int,
    ): Boolean {
        val request = buildHighlightlyLiveRefreshRequest(date, competitionId, ttlMinutes)
        val token = FirebaseSession.currentIdToken() ?: return false

        val init = js("({ method: 'POST', headers: { 'Content-Type': 'application/json' } })")
        init.headers["Authorization"] = "Bearer $token"
        init.body = request.body

        return try {
            val resp = (fetchFn()(request.url, init) as Promise<dynamic>).await()
            resp.ok == true
        } catch (_: Exception) {
            false
        }
    }

    internal fun buildHighlightlyLiveRefreshRequest(
        date: String,
        competitionId: String,
        ttlMinutes: Int,
    ): HighlightlyLiveRefreshRequest {
        val cfg = js("window.__FOOTYGUIDE_CONFIG__")
        if (cfg == null || cfg == undefined) error("__FOOTYGUIDE_CONFIG__ nao encontrado")
        val baseUrl = cfg.apiBaseUrl as String
        val function = if (FirestoreDatabase.configuredId() == FirestoreDatabase.DEV) {
            "highlightlyLiveRefreshDev"
        } else "highlightlyLiveRefresh"
        val url = "$baseUrl/$function"
        val body = """{"date":"$date","competitionId":"$competitionId","ttlMinutes":$ttlMinutes}"""
        return HighlightlyLiveRefreshRequest(url = url, body = body)
    }

    private fun fetchFn(): dynamic = js("globalThis.fetch.bind(globalThis)")
}
